import { render, staticRenderFns } from "./newIndex.vue?vue&type=template&id=4fc6efce&scoped=true"
import script from "./newIndex.vue?vue&type=script&lang=js"
export * from "./newIndex.vue?vue&type=script&lang=js"
import style0 from "./newIndex.vue?vue&type=style&index=0&id=4fc6efce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc6efce",
  null
  
)

export default component.exports